angular.module('zc').component('zcDashboardConversionPriceChart', {
  templateUrl: '/templates/projects.dashboard/conversion_price_chart.html',
  bindings: {
    project: '<',
    chart: '<',
  },
  controller: zcDashboardConversionPriceChartController
});

zcDashboardConversionPriceChartController.$inject = [
  '$scope',
  '$translate',
  '$window',
  'ChartV2',
  'lineChartV2Config'
];

function zcDashboardConversionPriceChartController($scope, $translate, $window, ChartV2, lineChartV2Config) {
  const vm = this;

  $scope.$watch('$ctrl.project', project => {
    if(!project || !project.thisMonthStat) return;
    setChartConfig();
  });

  function setChartConfig() {
    const campaignConversionPrices = [];
    const campaignConversionPriceRates = [];

    _.each(vm.project.dailyStats, stat => {
      const startAtUnixTime = moment(stat.start_at).valueOf();
      const conversionCountRatio = stat.all_campaign.conversion_price / stat.all_access.conversion_price * 100;

      campaignConversionPrices.push([
        startAtUnixTime,
        stat.all_campaign.conversion_price,
      ]);

      campaignConversionPriceRates.push([
        startAtUnixTime,
        conversionCountRatio,
      ]);
    });

    const chart = new ChartV2(lineChartV2Config, {
      yAxis: [{
        title: { text: null },
        min: 0,
        labels: {
          formatter: function() {
            return `${$window.Highcharts.numberFormat(this.value, 0)} 円`;
          }
        },
      },
      {
        opposite: true,
        title: { text: null },
        min: 0,
        labels: {
          formatter: function() {
            return `${$window.Highcharts.numberFormat(this.value, 2)} %`;
          }
        }
      }
      ],
    });

    chart.addSeries({
      type: 'column',
      name: $translate.instant('projectsDashboard.conversionPriceChart.campaignConversionPrices'),
      data: campaignConversionPrices,
      tooltip: {
        valueDecimals: 0,
      },
      yAxis: 0,
    });

    chart.addSeries({
      type: 'line',
      name: $translate.instant('projectsDashboard.conversionPriceChart.campaignConversionPriceRates'),
      data: campaignConversionPriceRates,
      tooltip: {
        valueSuffix: ' %',
        valueDecimals: 1
      },
      yAxis: 1,
    });

    vm.chartConfig = chart.getConfig();
    _.merge(vm.chartConfig.options, {
      chart: {
        width: vm.chart.chart_width,
        height: vm.chart.chart_height,
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.dashboard/conversion_price_chart.controller.js